export const isRtl = (): boolean => {
    return (document.querySelector('html').getAttribute('dir') || '') === 'rtl';
};
